import { render, staticRenderFns } from "./FormatStrikethroughIcon.vue?vue&type=template&id=1cbf417b"
import script from "./FormatStrikethroughIcon.vue?vue&type=script&lang=js"
export * from "./FormatStrikethroughIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports